import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import InputField from "../InputField";
import searchIcon from "../../../../../assets/images/searchIcon.svg";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { Country, State } from "country-state-city";
import arrow from "../../../../../assets/images/arrow.png";
import "./style.scss";
import Button from "../Button";
import Pagination from "react-js-pagination";
import GlobalDropDown2 from "../GlobalDropDown2";
import axios from "axios";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import Select from "react-select";
import ChatBoxModal from "../../../../common/chatBoxModal";
import api from "../../../../common/dependencies/utils/Api";

import { Button as MaterialButton } from "@material-ui/core";
import { getNamesList } from "../AdminMentorAction/dependencies/action";
import { GET_ACTIVITY_SUMMARY_MENTOR_DATA,DOWNLOAD_EXCEL_MENTOR_NOT_LOGGED_IN } from "../../../../common/constants/ApplicationUrl";

import mentorMiniIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import startupMiniCircle from "../../../../../assets/svg/startupMiniCircle.svg";
import mentorIcon from "../../../../../assets/images/Icon_Mentor_White.svg";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import {
  getActivitySummaryPerformance,
  getPredefineOptionsList,
} from "../AdminMentorAction/dependencies/action";
import * as moment from "moment";

// import {
//   getAdminMentorList,
//   getPredefineOptionsList,
//   getMentorlistCountersList,
//   // getNamesList
// } from "./dependencies/action";

export const ColumnNameAdmin = [
  {
    value: "sn",
    text: "NO.",
    sort: false,
  },
  {
    value: "mentorName",
    text: "MENTOR NAME",
    sort: true,
  },
  {
    ra3: "dpiitid",
    text: "MENTOR ID",
    sort: true,
  },
  {
    value: "applicationid",
    text: "APPLICATION ID",
    sort: true,
  },
  {
    value: "applicationdate",
    text: "APPLICATION DATE",
    sort: true,
  },
  {
    value: "applicationform",
    text: "APPLICATION FORM",
    sort: false,
  },
  {
    value: "applicationstatus",
    text: "APPLICATION STATUS",
    sort: false,
  },
  {
    value: "comments",
    text: "COMMENTS",
    sort: false,
  },
];
const customStyles = {
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
};

const ActivityInactivity = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const html = document.getElementsByTagName("html")[0];
  const headeradmintext = useRef(null);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [page, setPage] = useState(0);
  const [activeText, setActiveText] = useState(true);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [sortField, setSortField] = useState("fellowName");
  const [sortOder, setSortOrder] = useState("DESC");
  const [selectedRow, setSelectedRow] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [maxTotalCount, setMaxTotalCount] = useState(0);
  const {
    getNamesList,
    getNamesListData,
    getActivitySummaryPerformance,
    getTableData,
    getTablePaginate,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();

  const defaultFormData = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const defaultFormData2 = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      status: "NotLoggedIn",
      country: formData?.country?.value == null ? "" : formData?.country?.label,
      state:
        formData?.state?.value == "select" ||
        formData?.state == "" ||
        formData?.state == null
          ? ""
          : formData.state.value, // optional
      industry:
        formData?.industry?.value == "select" || formData?.industry == ""
          ? ""
          : formData?.industry?.value, // optional
      function:
        formData?.function?.value == "select" || formData?.function == ""
          ? ""
          : formData?.function?.value, // optional
      stage:
        formData?.stage?.value == "select" || formData?.stage == ""
          ? ""
          : formData?.stage?.value,
      mentorId: "",
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getActivitySummaryPerformance(params);
  };
  const [formData, setFormData] = useState(defaultFormData);
  const newCountryArray = [];
  const newStateArray = [];
  const [appliedformData, setAppliedFormData] = useState(defaultFormData2);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const history = useHistory();
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [nameListData, setNamesListData] = useState([]);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getAdminMentorList,
    mentorList,
    getPredefineOptionsList,
    getMentorlistCountersList,
    getCounter,
    getPredefineOptions,
    mentorListPaginate,
  } = props;
  useEffect(() => {
    html.style.overflow = "auto";

    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[2].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[2].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[2].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    // let params = {
    //   listKey: "Mentor",
    // };
    // getNamesList(params);

    // axios({
    //   url: GET_ACTIVITY_SUMMARY_MENTOR_DATA,
    //   method: "post",
    //   data: {
    //     // mentorId:
    //     //   localStorage.getItem("SavedLoggedInData") &&
    //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Mentor",
    //     status: "NotLoggedIn",
    //   },
    // })
    api
      .POST(GET_ACTIVITY_SUMMARY_MENTOR_DATA, {
        // mentorId:
        //   localStorage.getItem("SavedLoggedInData") &&
        //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Mentor",
        status: "NotLoggedIn",
      })
      .then((res) => {
        setNamesListData(res.data.data);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let params = {
      listKey: "Mentor",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    let nameArrList = [];
    nameListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Mentor",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (nameListData?.length >= nameListValue?.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [nameListData]);
  useEffect(() => {
    let params = {
      status: "NotLoggedIn",
      industry: "",
      function: "",
      state: "",
      mentorId: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getActivitySummaryPerformance(params);
  }, []);
  useEffect(() => {
    if (getTablePaginate && getTablePaginate?.totalElements > maxTotalCount) {
      setMaxTotalCount(getTablePaginate?.totalElements);
    }
  }, [getTablePaginate]);

  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);
    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);
        setNewStateOptions(newStateArray);
      }
    );
    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const sortCloumn = (name) => {
    if (sortField === name) {
      setSortField(name);
      setSortOrder(sortOder === "DESC" ? "ASC" : "DESC");
    } else {
      setSortField(name);
    }
  };
  const getMentorId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const ViewMentorApplicaiton = (applicationId, applicationStatus) => {
    setSelectedRow(applicationId);

    let reRoute = window.open(sample + "/view-application", "_blank");
    reRoute.id = applicationId;
    reRoute.applicationStatus = applicationStatus;
    reRoute.fromModule = "mentorList";
  };
  const ViewApplication = (dpiitNo) => {
    let reRoute = window.open(sample + "/view-StartupApplication", "_blank");
    reRoute.id = dpiitNo;
    reRoute.fromModule = "startUpApplications";
  };
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
  };
  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const getSummaryListName = (name) => {
    let params = {
      status: "NotLoggedIn",
      country: formData?.country?.value == null ? "" : formData?.country?.label,
      state:
        formData?.state?.value == "select" ||
        formData?.state == "" ||
        formData?.state == null
          ? ""
          : formData.state.value, // optional
      industry:
        formData?.industry?.value == "select" || formData?.industry == ""
          ? ""
          : formData?.industry?.value, // optional
      function:
        formData?.function?.value == "select" || formData?.function == ""
          ? ""
          : formData?.function?.value, // optional
      stage:
        formData?.stage?.value == "select" || formData?.stage == ""
          ? ""
          : formData?.stage?.value,
      mentorId: name == "Select" || name == undefined ? "" : name,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getActivitySummaryPerformance(params);
  };
  const handleInputChange = (e, name) => {
    const { value } = e.target;

    setFormData((user) => {
      return { ...user, [name]: value };
    });

    const newFormData = {
      ...formData,
      [name]: value,
    };

    localStorage.setItem("formdata", JSON.stringify(newFormData));

    setAppliedFormData(newFormData);
  };
  const getExcelMentorDownload = () => {
    api
      .GET(`${DOWNLOAD_EXCEL_MENTOR_NOT_LOGGED_IN}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `MentorNotLoggedInPast15Days.xls`);
        document.body.appendChild(link);
        link.click();
      });
  };
  return (
    <>
      <div
        className="activityMentorTable3"
        style={{ marginTop: props.location.state?.pageLink ? "100px" : "0px" }}
      >
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div className="topbackbtnparentdiv">
            <div
              className="dashboard-bottom-btn4 topbackbtnmentorlist"
              style={{ background: "transparent", border: "none" }}
            >
              <div className="newuserTooltip">
                <MaterialButton
                  className="topbackbtnactual top-btn"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (
                      props.location.state.fromModule === "mentorDashboardHome"
                    ) {
                      localStorage.setItem(
                        "mentorDashboardHome",
                        "mentorDashboardHome"
                      );
                      window.location.reload();
                    } else if (
                      history?.location?.state?.fromModule === "activitySummary"
                    ) {
                      localStorage.setItem(
                        "activitySummary",
                        "activitySummary"
                      );

                      window.location.reload();
                    } else {
                      localStorage.setItem("mentorMenu", "mentorMenu");

                      window.location.reload();
                    }
                  }}
                  style={{
                    background: "#3ac2d7",
                  }}
                >
                  {" "}
                  Back
                </MaterialButton>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{
                    top: "69px",
                    width: "217px",
                    left: "71px",
                  }}
                >
                  Click to Go Activity Summary
                </span>
              </div>
            </div>
          </div>
          <div className="iconWith-heading iconheadingdata">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading">
                ACTIVITY SUMMARY: NOT LOGGED IN{" "}
              </h3>
            </div>
            {/* <a onClick={() => getExcelMentorDownload()}>
              <div className="newuserTooltip">
                <img
                  className="excelButton excelbuttonadmindash"
                  src={excelButton}
                  style={{ top: "2.4rem", width: "47%", left: "0rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "0.5rem", top: "5.75rem", width: "12vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a> */}
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-11 display-center mobilementorsummary">
          <div className="admin-bottom-card row">
            <div
              className="mentorImageParent d-flex justify-content-end"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorIcon} className="sidebar-dashboard-icon2" />
            </div>
            <div className="dashboard-bottom-btn3">
              <p className="text-white">MENTORS</p>
            </div>
            <div class="w-20 newuserTooltip circleBorder maxtotalCount">
              {maxTotalCount}
            </div>
            <div class="w-40 newuserTooltip activitySummaryText last15days">
              Not Logged In Since Last 15 days
            </div>
            {/* <div class="w-20 newuserTooltip">
             X
            </div> */}
          </div>
          <div className="filter-row filter-row-common">
            <div>
              <form className="container containerfixtable">
                <Modal
                  modalOpen={modalOpen}
                  setModalOpen={setModalOpen}
                  modalData={modalData}
                />
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between filtrdroppeddata ">
                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.value);
                          getSummaryListName(e.value);
                          //   setFilterNameValue(e.value);
                          //   getMentorListName(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Mentor"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Mentor
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />

                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="country"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="country"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.country}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              country: e.value == "select" ? null : e,
                            };
                          });

                          setFilterCountry(e.label);

                          if (e.label === "India") {
                            setNewCountrySelect(true);
                            setFilterState("");
                          } else {
                            setNewCountrySelect(false);
                            setFilterState("");
                            setFormData((user) => {
                              return {
                                ...user,
                                state: "",
                              };
                            });
                          }
                          setNewStateOptions("");
                        }}
                        options={newCountryOptions}
                        placeholder="Country"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Country
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown3 filterdrop dropDownWidthFix3 newuserTooltip">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>
                  <div className="col-1 apply-section mentorGoBtnFix newuserTooltip gohidemb">
                    <Button
                      onClick={() => getSummaryListName(filterName)}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                  {/* <div className="col-md-1 apply-section applymentorlistbtnmobile">
                    <Button
                      type="submit"
                      text="GO"
                      className="green-btn filter-btn"
                      onClick={() => getSummaryListName(filterName)}
                    />
                  </div> */}
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div>
                    <InputField
                      type="search"
                      name="search"
                      placeholder="Search Technology"
                      value={formData.search}
                      onChange={handleInputChange}
                      containerClass={"form-group"}
                      className="subscribe-input-field"
                    />
                    <div className="btn-group">
                      <Button
                        icon={<img src={searchIcon} className="search-icon" />}
                        type="submit"
                        text=""
                        className="list-submit-button"
                      />
                    </div>
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <GlobalDropDown2
                      label="."
                      containerStyle="form-group "
                      selectTagStyle="form-control dropdown-media"
                      name={"thematic"}
                      defaultOptionText={"Select Thematic"}
                      error=""
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <GlobalDropDown2
                      label="."
                      containerStyle="form-group"
                      selectTagStyle="form-control dropdown-media"
                      name={"origin"}
                      defaultOptionText={"Select Origin"}
                      error=""
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <GlobalDropDown2
                      label="."
                      containerStyle="form-group "
                      selectTagStyle="form-control dropdown-media"
                      name={"readiness"}
                      defaultOptionText={"Select Tech Readiness"}
                      error=""
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <GlobalDropDown2
                      label="."
                      containerStyle="form-group "
                      selectTagStyle="form-control dropdown-media"
                      name={"recognized"}
                      defaultOptionText={"Recognized By"}
                      error=""
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <GlobalDropDown2
                      label="."
                      containerStyle="form-group "
                      selectTagStyle="form-control dropdown-media"
                      name={"state"}
                      defaultOptionText={"Select State"}
                      error=""
                    />
                  </div>

                  <div className="col-md-1 apply-section">
                    <Button
                      type="submit"
                      text="Apply"
                      className="green-btn filter-btn"
                      //   onClick={() => getMentorList(selectedStatus)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="totalTableCount">
            Total Records Found :{" "}
            {getTablePaginate && getTablePaginate.totalElements} &lt;{" "}
            {getTablePaginate && getTablePaginate.currentPage} of{" "}
            {getTablePaginate && getTablePaginate.numPages} &gt;
          </div>
          {getTableData && getTableData?.length > 0 ? (
            <div className="allMentor-table">
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className=" fixColumbnWidth4"
                      >
                        <div>NO.</div>
                      </th>
                      <th
                        className="fixColumbnWidth"
                        colspan="2"
                        style={{
                          minWidth: "16.9rem",
                          maxWidth: "17rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>MENTOR DETAILS</div>
                      </th>
                      <th style={{ verticalAlign: "middle" }}>
                        <div>REQUESTS RECEIVED</div>
                      </th>
                      <th style={{ verticalAlign: "middle" }}>
                        <div> REQUEST DATE REQUIREMENT ID</div>
                      </th>
                      <th
                        style={{
                          minWidth: "14.9rem",
                          maxWidth: "16rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>REQUEST SENT BY STARTUP</div>
                      </th>
                      <th style={{ verticalAlign: "middle" }}>
                        LAST LOGGED IN
                      </th>
                      <th style={{ verticalAlign: "middle" }}>MESSAGE</th>
                    </tr>
                  </thead>

                  <tbody>
                    {getTableData.map((item, index) => (
                      <tr className="resallreqtr">
                        <td>
                          <div>
                            {index +
                              1 +
                              10 * (getTablePaginate.currentPage - 1)}
                          </div>
                        </td>

                        <td
                          className="resallreqtrtd2"
                          // style={{minWidth:"19.9rem",maxWidth:"20rem"}}
                        >
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              src={
                                item.user.image !== null &&
                                item.user.image !== ""
                                  ? item.user.image
                                  : hashImage
                              }
                              onClick={() =>
                                ViewProfile(item?.user.username, item?.user.id)
                              }
                              // src={
                              //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                              // }
                              className="sidebar-dashboard-icon2 newWidthIconFIx"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                                // maxWidth: "none",
                                // objectFit: "contain",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "46px",
                                top: "94px",
                                width: "150px",
                              }}
                            >
                              View Mentor Profile
                            </span>
                          </div>
                        </td>
                        <td className="controlTableWidth newtablewidthactsummnotloggedin">
                          <div className="controlDetailasBox">
                            <div>{item.user.applicant_name}</div>
                            <div
                              className="color-green"
                              style={{ width: "fit-content" }}
                            >
                              {"M" +
                                item.user.id.substring(item.user.id.length - 6)}
                            </div>
                            <div>{item.user.organization_name}</div>
                            <div>{item.user.current_designation}</div>
                            <div>{item.user.city}</div>
                          </div>
                          <div
                            className="d-flex justify-content-end newuserTooltip"
                            style={{
                              cursor: "pointer",
                              alignItems: "end",
                              justifyContent: "center",
                              width: "40px",
                              display: "flex",
                              float: "right",
                            }}
                            onClick={() =>
                              ViewProfile(item?.user.username, item?.user.id)
                            }
                          >
                            <img
                              src={mentorMiniIcon}
                              style={{ minWidth: "2.5rem" }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={{
                                left: "15px",
                                top: "45px",
                                width: "150px",
                              }}
                            >
                              View Mentor Profile
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>{item.totalRequests}</div>
                        </td>
                        <div className="activityTable3MobileDiv">
                          <h6 style={{ fontWeight: "bold", fontSize: "13px" }}>
                            REQUEST DATE REQUIREMENT ID / REQUEST SENT BY
                            STARTUP
                          </h6>
                          {item.requests !== undefined &&
                            item.requests.map(function (key, index) {
                              return (
                                <>
                                  <div className="borderStartUp91 borderstartup91innerbox">
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                      className="borderstartup91undercontent"
                                    >
                                      <div
                                        style={{
                                          justifyContent: "end",
                                          display: "flex",
                                        }}
                                      >
                                        {moment(key.requestToMentorDate).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </div>

                                      <div className="newuserTooltip borderstartup91undercontent2">
                                        <div
                                          className="color-green"
                                          style={{
                                            width: "fit-content",
                                            cursor: "pointer",
                                            display: "flex",
                                            justifyContent: "end",
                                            float: "right",
                                          }}
                                          onClick={() => {
                                            // setIndexCounter(item.requestId);
                                            setModalData(key.requestJson);
                                            setModalOpen(true);
                                          }}
                                        >
                                          {"S" +
                                            key.id.substring(
                                              key?.id.length - 6
                                            )}
                                        </div>
                                        <span
                                          className="tooltiptext tooltip-bottom"
                                          style={{
                                            left: "2.5rem",
                                            top: "2.15rem",
                                            width: "221px",
                                          }}
                                        >
                                          View Mentorship Requirement
                                        </span>
                                      </div>
                                    </div>

                                    <div
                                      style={
                                        {
                                          // display: "flex",
                                          // justifyContent: "center",
                                        }
                                      }
                                      className="borderstartup91undercontent2ndone"
                                    >
                                      <div>
                                        {key.startupName}
                                        <div
                                          className="newuserTooltip "
                                          style={{
                                            width: "fit-content",
                                          }}
                                        >
                                          {key.dpiitNumber}
                                        </div>
                                      </div>
                                      <div
                                        className="d-flex justify-content-end newuserTooltip borderstartup91undercontent2ndoneicon"
                                        style={{
                                          cursor: "pointer",
                                          alignItems: "end",
                                          // justifyContent: "end",
                                          // display: "flex",
                                        }}
                                        onClick={() => {
                                          redirectProfile(key.dpiitNumber);
                                        }}
                                      >
                                        <img
                                          src={startupMiniCircle}
                                          className="startupCircleWidth startupcirclewidthnewone"
                                          // style={{
                                          //   width: "40px",
                                          //   position: "relative",
                                          //   top: "0.7rem",
                                          //   right: "0.4rem",
                                          //   paddingBottom: "1rem",
                                          // }}
                                        />
                                        <span
                                          className="tooltiptext tooltip-bottom"
                                          style={{
                                            left: "212px",
                                            top: "57px",
                                            width: "150px",
                                          }}
                                        >
                                          View Startup Profile
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                        <td
                          className="matchList-tooltip p-0 activityTable3WebDiv activityTable3WebWidth"
                          style={{ minWidth: "10.2rem", maxWidth: "10.25rem" }}
                        >
                          {item.requests !== undefined &&
                            item.requests.map(function (key, index) {
                              return (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "",
                                    }}
                                    className="borderStartUp91"
                                  >
                                    <div>
                                      {moment(key.requestToMentorDate).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </div>

                                    <div className="newuserTooltip">
                                      <div
                                        className="color-green"
                                        style={{
                                          width: "fit-content",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          // setIndexCounter(item.requestId);
                                          setModalData(key.requestJson);
                                          setModalOpen(true);
                                        }}
                                      >
                                        {"S" +
                                          key.id.substring(key?.id.length - 6)}
                                      </div>
                                      <span
                                        className="tooltiptext tooltip-bottom"
                                        style={{
                                          left: "2.5rem",
                                          top: "2.15rem",
                                          width: "221px",
                                        }}
                                      >
                                        View Mentorship Requirement
                                      </span>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </td>
                        <td className="matchList-tooltip p-0 activityTable3WebDiv">
                          {item.requests !== undefined &&
                            item.requests.map(function (key, index) {
                              return (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      // justifyContent: "center",
                                    }}
                                    className="borderStartUp91"
                                  >
                                    <div>
                                      {key.startupName}
                                      <div
                                        className="newuserTooltip "
                                        style={{
                                          width: "fit-content",
                                        }}
                                      >
                                        {key.dpiitNumber}
                                      </div>
                                    </div>
                                    <div
                                      className="d-flex justify-content-end newuserTooltip"
                                      style={{
                                        cursor: "pointer",
                                        alignItems: "end",
                                        justifyContent: "end",
                                        display: "flex",
                                      }}
                                      onClick={() => {
                                        redirectProfile(key.dpiitNumber);
                                      }}
                                    >
                                      <img
                                        src={startupMiniCircle}
                                        style={{
                                          width: "40px",
                                          position: "relative",
                                          top: "0.7rem",
                                          right: "0.4rem",
                                          paddingBottom: "1rem",
                                        }}
                                      />
                                      <span
                                        className="tooltiptext tooltip-bottom"
                                        style={{
                                          left: "212px",
                                          top: "57px",
                                          width: "150px",
                                        }}
                                      >
                                        View Startup Profile
                                      </span>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </td>

                        <td>
                          <div>
                            <div>
                              {moment(item.user.lastLogin).format("DD/MM/YYYY")}
                              <br></br>
                            </div>
                          </div>
                        </td>
                        <td className="specialtddd">
                          <div
                            className=""
                            style={{
                              cursor: "pointer",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100px",
                              width: "50px",
                              display: "flex",
                            }}
                            onClick={() => {
                              setChatBoxModalOpen(true);
                              setMentorRequest(item.user);
                              setMentorRequestId(item.user.id);
                            }}
                          >
                            <div className="newuserTooltip">
                              <img
                                src={buttonSendMessage}
                                style={{
                                  height: "90%",
                                  width: "80%",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  top: "46px",
                                  left: "20px",
                                  width: "126px",
                                }}
                              >
                                Send Message
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {/* {mentorList && mentorList.length > 0 ? ( */}
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={getTablePaginate.totalElements}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange.bind(this)}
                  />
                  {/* ) : (
                    ""
                  )} */}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          <ChatBoxModal
            modalVisibility={chatBoxModalOpen}
            setModalVisibility={setChatBoxModalOpen}
            receiverInfo={mentorRequest}
            receiverId={mentorRequestId}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    mentorList: state.AdminMentorListReducer.getMentorList.data,
    mentorListPaginate: state.AdminMentorListReducer.getMentorList.paginate,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCounter: state.AdminMentorListReducer.getMentorlistCountersList.data,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.AdminMentorReducer.getActivitySummaryPerformance.data,
    getTablePaginate:
      state.AdminMentorReducer.getActivitySummaryPerformance.paginate,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};

export default connect(mapStateToProps, {
  //   getAdminMentorList,
  //   // predefineOptions,
  getPredefineOptionsList,
  //   getMentorlistCountersList,
  getActivitySummaryPerformance,
  getNamesList,
  getStepperTooltipData,
})(withRouter(ActivityInactivity));
